import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { Button, Grid, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

interface Props {
  deviceName: string;
  isDeleteDeviceButtonVisible: boolean;
  handleOpenDeleteDeviceModal: () => void;
}

const Header: React.FC<Props> = ({ deviceName, isDeleteDeviceButtonVisible, handleOpenDeleteDeviceModal }) => {
  const { translation } = useTranslation();

  return (
    <Grid container justifyContent="space-between">
      <Grid container direction="column">
        <Grid container spacing={2}>
          <Typography
            variant="h4"
            color="textPrimary"
            sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {deviceName}
          </Typography>
        </Grid>
      </Grid>
      {isDeleteDeviceButtonVisible && (
        <Button
          id="delete-device-button"
          onClick={handleOpenDeleteDeviceModal}
          size="small"
          color="error"
          variant="text"
          startIcon={<DeleteOutlined color="error" />}
        >
          {translation.delete_device}
        </Button>
      )}
    </Grid>
  );
};

export default Header;
